module.exports = __webpack_public_path__ + "static/media/icon-home-tag5.b983020d.png";